import { ShareableGrantFull } from '@bindoc-projects/bindoc-permissions-lib/data';
import {
  SHAREABLE_TYPE_DISPLAY_NAME,
  ShareableType,
} from '@bindoc-projects/resource-domain-lib';

import { FolderItem } from '../shareables-overview.models';

/**
 * A grant as a row of the shared list. A folder can be shared like any other
 * resource ("Freigeben" is offered on folders), so a folder grant is a folder
 * row: folder icon, and opening it goes to the folder in the workspace through
 * the `folder` detail route (BDA-6454).
 */
export function grantToFolderItem(grant: ShareableGrantFull): FolderItem {
  const ref = grant.shareableReference;
  return {
    id: ref.id,
    type: ref.type,
    isFolder: ref.type === ShareableType.FOLDER,
    name: ref.name ?? ref.id,
    typeLabel: SHAREABLE_TYPE_DISPLAY_NAME[ref.type] ?? ref.type,
    modifiedDate: ref.modifiedDate?.toString(),
    parentFolderId: ref.parentFolderId,
    labels: ref.labels,
    allowedPermissions: ref.allowedShareablePermissions,
  };
}
